import script from "./info-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./info-item.vue?vue&type=script&lang=ts&setup=true"

import "./info-item.vue?vue&type=style&index=0&id=512d83d8&lang=scss"
import "./info-item.vue?vue&type=style&index=1&id=512d83d8&lang=scss"

const __exports__ = script;

export default __exports__